import { ActionIcon, Image, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

export const CoverageQaProductCard = ({
  productId,
  name,
  imageUrl,
  onRemove,
}: {
  productId: string;
  name: string;
  imageUrl?: string;
  onRemove?: () => void;
}) => (
  <div className="flex items-center gap-2 rounded border border-gray-200 bg-gray-50 p-2">
    {imageUrl ? (
      <Image
        src={imageUrl}
        alt={name}
        w={onRemove ? 32 : 40}
        h={onRemove ? 32 : 40}
        fit="contain"
        className="rounded border border-gray-100 bg-white flex-shrink-0"
      />
    ) : (
      <div
        className={`${onRemove ? "h-8 w-8" : "h-10 w-10"} rounded bg-gray-200 flex items-center justify-center flex-shrink-0`}
      >
        <Text size="xs" c="dimmed">?</Text>
      </div>
    )}
    <div className="min-w-0 flex-1">
      <Text size={onRemove ? "xs" : "sm"} fw={500} lineClamp={onRemove ? 1 : 2}>
        {name}
      </Text>
      {!onRemove && (
        <Text size="xs" c="dimmed">{productId.slice(-8)}</Text>
      )}
    </div>
    {onRemove && (
      <ActionIcon size="xs" variant="subtle" color="gray" onClick={onRemove}>
        <IconX size={12} />
      </ActionIcon>
    )}
  </div>
);
